import {
  ADD_SNACKBAR_MESSAGE,
  REMOVE_SNACKBAR_MESSAGE,
} from './SnackbarActions';

const DEFAULT_STATE = {
  messages: {},
};

const actionsMap = {
  [ADD_SNACKBAR_MESSAGE]: handleAddMessage,
  [REMOVE_SNACKBAR_MESSAGE]: handleRemoveMessage,
};

export default function Snackbar(state = DEFAULT_STATE, action = {}) {
  // @ts-expect-error TS(2339): Property 'type' does not exist on type '{}'.
  const { type } = action;
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  if (actionsMap[type]) {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return actionsMap[type](state, action);
  }
  return state;
}

function handleAddMessage(state: any, action: any) {
  const {
    response: { message },
  } = action;
  return {
    ...state,
    messages: {
      ...state.messages,
      [message.id]: message,
    },
  };
}

function handleRemoveMessage(state: any, action: any) {
  const {
    response: { id },
  } = action;
  const messagesState = { ...state.messages };
  delete messagesState[id];

  return {
    ...state,
    messages: messagesState,
  };
}
